import React from 'react';

import { PostHogProvider } from 'posthog-js/react'
import NewAccount from '../../Teacher/components/accounts/new/new_account_stage1.jsx';
import DemoAccountContextProvider from '../../Teacher/contexts/DemoAccountContextProvider';

const options = {
  api_host: window.postbuildEnv.PUBLIC_POSTHOG_HOST,
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  properties: {
    environment: window.postbuildEnv.RAILS_ENV
  }
}

export default ({ isDemo = false, ...props }) => (
  <PostHogProvider apiKey={window.postbuildEnv.PUBLIC_POSTHOG_KEY} options={options}>
    <DemoAccountContextProvider isDemo={isDemo}>
      <NewAccount {...props} />
    </DemoAccountContextProvider>
  </PostHogProvider>
);



